import { useCallback } from 'react';

import { client, useErrorNotifications } from 'core/http';

export default function useMaestroExport() {
  const showErrorNotification = useErrorNotifications();

  const exportMaintenance = useCallback(
    id => {
      return client()
        .put<{ id: number; external_id: number }>(`maintenances/${id}/export`)
        .then(response => response.data)
        .catch(e => {
          showErrorNotification(e);
        });
    },
    [showErrorNotification]
  );

  return { exportMaintenance };
}
